export default __webpack_public_path__ + "static/media/Leggings of Intricate Spite.f37e7fc9.jpg";